import { createFileRoute, Link } from "@tanstack/react-router";
import { Button } from "@mui/material";
import HgBreadcrumbs from "@/common/components/ui/atoms/HgBreadcrumbs";
import AdminContentList from "@/features/contents/components/admin/AdminContentList";
import { useContentPermissions } from "@/pages/admin/content";

export const Route = createFileRoute("/app/admin/content/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { userCanViewAllContent, userCanEditAllContent } = useContentPermissions();

  return (
    <>
      <HgBreadcrumbs
        options={[
          { title: "Admin", link: null, unlink: true },
          { title: "Content", link: null },
        ]}
      />
      <h1>Content Management</h1>

      <p>
        <Button
          disabled={!userCanEditAllContent}
          color="primary"
          component={Link}
          to="/app/admin/content/new"
          variant="contained"
          size="small"
        >
          Add Content
        </Button>
      </p>

      <AdminContentList
        itemsPerPage={25}
        renderVersion={0}
        tableSize="medium"
        userCanViewAllContent={userCanViewAllContent}
      />
    </>
  );
}
